import type { UserSetPasswordSettingsInput } from '../../../base-api/Api'
import { api } from '../../api'

export const getPasswordSettings = async () => {
  return await api.v1.userGetPasswordSettings()
}

export const setPasswordSettings = async (
  data: UserSetPasswordSettingsInput,
) => {
  return await api.v1.userSetPasswordSettings(data)
}
